import { useEffect, useState } from "react";
import { getUserProperties } from "src/modules/users/api";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectUsers } from "src/modules/users/selector";

export function usePersonalAvatar(email: string | undefined) {
  const [image, setImage] = useState<string | null>(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const users: any = useAppSelector(selectUsers);

  useEffect(() => {
    if (email && !users[email.toLowerCase().trim()]) {
      setLoadingImage(true);
    } else if (email && users[email.toLowerCase().trim()]) {
      setImage(users[email.toLowerCase().trim()]['avatar']);
      setLoadingImage(false);
    }
  }, [users]);

  return { loadingImage, image };
}
